import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormFocusDirective } from '../directives/form-focus.directive';
import { InputDialogData } from './models/input-dialog-data';
import { InputDialogResult } from './models/input-dialog-result';

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss'],
    imports: [MatCardModule, FormsModule, FormFocusDirective, MatFormFieldModule, MatInputModule, MatButtonModule]
})
export class InputDialogComponent {
    dialogData: InputDialogData;
    title: string;
    message: string;

    value: string;

    constructor(
        public dialogRef: MatDialogRef<InputDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: InputDialogData
    ) {
        console.log('InputDialogComponent data : ', data);
        this.value = data.value;
    }

    onConfirm(): void {
        var result = new InputDialogResult(true, this.value);
        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    onDismiss(): void {
        var result = new InputDialogResult(false);
        // Close the dialog, return false
        this.dialogRef.close(result);
    }
}
